export const kAppConstants = {
  name: "ChoreBuddy",
  description: "Manage your chores with ease.",
};
